module.exports = __webpack_public_path__ + "static/media/kerry-handout.b05d33d8.pdf";